export interface CustomDropdownOptionModel {
  name: string;
  value: string;
}

export enum CustomDropDownFacing {
  UP = 'UP',
  DOWN = 'DOWN',
}
